const MANAGE_USERS = {
  UPDATE_QUERIES_FOR_GET_USERS: 'USERS::UPDATE_QUERIES_FOR_GET_USERS',
  RESET_INITIAL_DATA: 'USERS::RESET_INITIAL_DATA'
};
export default MANAGE_USERS
